const headers = {
  name: "Tax Types",
  navigate: {
    path: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Tax Types",
        path: "/app/settings/tax/types",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;